"use client"

import {
  useProfileActiveLinkChecker,
  useProfilePageHref,
} from "@/app/navigation/profile"
import { ProfilePageType } from "@/app/navigation/profile/profile-page-type"
import { useWalletConnect } from "@/app/wallet-connect/hooks"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import { Trans } from "@lingui/react/macro"
import { NavigationTrigger } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import Link from "next/link"

export const ProfileLinkWrapper = reatomComponent<{
  className?: string
  onClick?: () => void
}>(({ className, onClick }) => {
  const { unionAddress } = useWalletConnect()
  if (!unionAddress) return <></>

  return (
    <ProfileLink
      unionAddress={unionAddress}
      className={className}
      onClick={onClick}
    />
  )
}, "ProfileLinkWrapper")

function ProfileLink({
  unionAddress,
  className,
  onClick,
}: {
  unionAddress: UnionAddress
  className?: string
  onClick?: () => void
}) {
  const profileHref = useProfilePageHref(unionAddress)
  const isProfilePage = useProfileActiveLinkChecker(
    unionAddress,
    ProfilePageType.ITEMS,
  )

  return (
    <Link href={profileHref} onClick={onClick}>
      <NavigationTrigger active={isProfilePage} className={className}>
        <Trans>Portfolio</Trans>
      </NavigationTrigger>
    </Link>
  )
}
